import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.27 6.02v3.73H8m10.98 4.23A7.256 7.256 0 0112 19.25c-4.01 0-7.25-3.24-7.25-7.25M12 4.75c4.01 0 7.25 3.24 7.25 7.25M5.15 9.8a7.238 7.238 0 016.91-5.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.73 17.98v-3.73H16"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.25 5.5v4.25H7.5m12.44 4.5c-.98 3.46-4.16 6-7.94 6-4.56 0-8.25-3.69-8.25-8.25M12 3.75c4.56 0 8.25 3.69 8.25 8.25M4.14 9.5A8.25 8.25 0 0112 3.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.75 18.5v-4.25H16.5"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15m24.88 9c-1.96 6.92-8.32 12-15.88 12-9.12 0-16.5-7.38-16.5-16.5M24 7.5c9.12 0 16.5 7.38 16.5 16.5M8.28 19C10.38 12.34 16.64 7.5 24 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M41.5 37v-8.5H33"
  }))
};
export var Repeat = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});